import { scroller } from "react-scroll";
import React from "react";
import { Box, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { observer } from "mobx-react";

type GridExpressProps = {
  links: Record<string, string>[];
  navigateTo?: string;
  navigateToHash?: string;
  contentTop: number;
  onNavigatedTo?: (id: string) => void;
};

export const NavigationBar: React.FC<GridExpressProps> = observer(
  ({ links, navigateTo, navigateToHash, contentTop, onNavigatedTo }) => {
    const scroll = React.useCallback(
      (to: string) => {
        scroller.scrollTo(to, {
          duration: 800,
          smooth: "easeInOutQuint",
          delay: 0,
          offset: -contentTop,
        });
        if (onNavigatedTo) {
          onNavigatedTo(to);
        }
      },
      [contentTop, onNavigatedTo]
    );

    const theme = useTheme();

    const handleNavigateTo = React.useCallback(
      (navigateTo: string | undefined, navigateToHash: string | undefined) => {
        if (navigateTo && navigateToHash) {
          scroll(navigateTo);
        }
      },
      // navigateTo y navigateToHash son parámetros del callback, no closures.
      // scroll está memoizado vía useCallback con sus propias deps.
      [scroll]
    );

    handleNavigateTo(navigateTo, navigateToHash);

    const buttons = links.map((x: any, index: number) => {
      return (
        <React.Fragment key={index}>
          <Button
            sx={{
              color: theme.palette.primary.dark,
              textTransform: "none",
            }}
            size={"small"}
            onClick={() => scroll(x.id)}
          >
            {x.label}
          </Button>
          {index < links.length - 1 && (
            <Box
              component="span"
              sx={{
                color: "text.secondary",
                px: 0.5,
                display: "flex",
                alignItems: "center",
              }}
            >
              |
            </Box>
          )}
        </React.Fragment>
      );
    });

    return (
      <Box
        sx={{
          ml: 0.5,
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {buttons}
      </Box>
    );
  }
);
